"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rcTree = _interopRequireWildcard(require("rc-tree"));

var _excluded = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var menuRenderer = /*#__PURE__*/function (_Component) {
  _inherits(menuRenderer, _Component);

  var _super = _createSuper(menuRenderer);

  function menuRenderer() {
    var _this;

    _classCallCheck(this, menuRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (value, event) {
      var _selectOption;

      var selected = event.selectedNodes.pop();
      var _this$props = _this.props,
          valueKey = _this$props.valueKey,
          labelKey = _this$props.labelKey,
          selectOption = _this$props.selectOption,
          selectNode = _this$props.selectNode;
      if (!selected || !event.selected || !selectNode && !selected.props.isLeaf) return null;
      return selectOption((_selectOption = {}, _defineProperty(_selectOption, valueKey, +selected.key), _defineProperty(_selectOption, labelKey, selected.props.title), _selectOption), event);
    });

    _defineProperty(_assertThisInitialized(_this), "getTreeChildren", function (options) {
      var nodes = [];
      options.forEach(function (option) {
        var children = option.children,
            restProps = _objectWithoutProperties(option, _excluded);

        var _this$props2 = _this.props,
            valueKey = _this$props2.valueKey,
            labelKey = _this$props2.labelKey,
            value = _this$props2.value,
            multi = _this$props2.multi;
        var nodeChildren = null;

        if (children && children.length) {
          nodeChildren = _this.getTreeChildren(children);
        }

        if (!multi || multi && !value.includes(option.id)) {
          nodes.push( /*#__PURE__*/_react["default"].createElement(_rcTree.TreeNode, _objectSpread(_objectSpread({}, restProps), {}, {
            title: option[labelKey],
            key: option[valueKey],
            isLeaf: !children
          }), nodeChildren));
        }
      });
      return nodes;
    });

    _defineProperty(_assertThisInitialized(_this), "getDefaultSelectedKeys", function () {
      var value = _this.props.value;
      if (!value) return [];

      if (Array.isArray(value)) {
        return value.map(function (item) {
          if (typeof item === 'number') {
            return String(item);
          }

          return item;
        });
      }

      return [String(value)];
    });

    return _this;
  }

  _createClass(menuRenderer, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          options = _this$props3.options,
          multi = _this$props3.multi;
      var TreeProps = {
        showLine: true,
        defaultExpandAll: true,
        defaultSelectedKeys: this.getDefaultSelectedKeys(),
        // {...props}
        onSelect: this.onSelect
      };
      if (multi) TreeProps.multiple = true;
      return /*#__PURE__*/_react["default"].createElement(_rcTree["default"], TreeProps, this.getTreeChildren(options));
    }
  }]);

  return menuRenderer;
}(_react.Component);

menuRenderer.propTypes = {
  // from react-select
  focusOption: _propTypes["default"].func,
  focusedOption: _propTypes["default"].object,
  inputValue: _propTypes["default"].string,
  instancePrefix: _propTypes["default"].string,
  onFocus: _propTypes["default"].func,
  onOptionRef: _propTypes["default"].func,
  onSelect: _propTypes["default"].func,
  optionClassName: _propTypes["default"].string,
  optionComponent: _propTypes["default"].func,
  optionRenderer: _propTypes["default"].func,
  options: _propTypes["default"].array,
  removeValue: _propTypes["default"].func,
  selectValue: _propTypes["default"].func,
  valueArray: _propTypes["default"].array,
  valueKey: _propTypes["default"].string,
  labelKey: _propTypes["default"].string,
  // my
  rest: _propTypes["default"].object,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].object, _propTypes["default"].array])
};
var _default = menuRenderer;
exports["default"] = _default;